import axios from "@/libs/api.request";
export function getNewsTreeList(params) {
    return axios.request({
        url: "NewsCompany/getNewsTreeList",
        method: "get",
        params:params,
    })
}

export function getNewsTreeData(params) {
    return axios.request({
        url: "NewsCompany/getNewsTreeData",
        method: "get",
        params:params,
    })
}
export function getCompanyNews(params) {
    return axios.request({
        url: "NewsCompany/getNewsList",
        method: "get",
        params:params,
    })
}

export function getNewsAllList(params) {
    return axios.request({
        url: "NewsCompany/getNewsAllList",
        method: "get",
        params:params,
    })
}
export function getNewsNoContentList(params) {
    return axios.request({
        url: "NewsCompany/getNewsNoContentList",
        method: "get",
        params:params,
    })
}

export function submitComPanyNews(params) {
    return axios.request({
        url: "NewsCompany/CreateUpdate",
        method: "post",
        headers: {
            'Content-Type': 'application/json'
        },
        data:params ,
    })
}

export function getinsNews(params) {
    return axios.request({
        url: "NewsIndustry/getNewsList",
        method: "get",
        params:params,
    })
}


export function submitInsNews(params) {
    return axios.request({
        url: "NewsIndustry/CreateUpdate",
        method: "post",
        headers: {
            'Content-Type': 'application/json'
        },
        data:params ,
    })
}
//技术支持
export function submitTecNews(params) {
    return axios.request({
        url: "NewsTechnical/CreateUpdate",
        method: "post",
        headers: {
            'Content-Type': 'application/json'
        },
        data:params ,
    })
}
export function getTecNews(params) {
    return axios.request({
        url: "NewsTechnical/getNewsList",
        method: "get",
        params:params,
    })
}

// 删除行业新闻
export function delInsnews(id) {
    return axios.request({
        url: "NewsIndustry/Delete",
        method: "post",
        params:{id:id}
    })
}
// 删除公司新闻
export function delComnews(id) {
    return axios.request({
        url: "NewsCompany/Delete",
        method: "post",
        params:{id:id}
    })
}
// 删除技术支持 
export function delTechnical(id) {
    return axios.request({
        url: "NewsTechnical/Delete",
        method: "post",
        params:{id:id}
    })
}